(function () {
  'use strict';

  function parseResponse(res) {
    if (typeof res !== 'string') {
      return res;
    }

    try {
      return JSON.parse(res);
    } catch (error) {
      console.error('elevator-nav-block27 flash_sale_data parse error:', error, res);
      return null;
    }
  }

  function getProductList(res) {
    if (Array.isArray(res)) {
      return res;
    }

    if (!res || typeof res !== 'object') {
      return [];
    }

    if (Array.isArray(res.data)) {
      return res.data;
    }

    if (Array.isArray(res.products)) {
      return res.products;
    }

    if (Array.isArray(res.data && res.data.products)) {
      return res.data.products;
    }

    return [];
  }

  function getFirstVariant(product) {
    return product.default_variant || (Array.isArray(product.variants) && product.variants[0]) || {};
  }

  function getProductImage(product, variant) {
    var firstImage = product.first_image;

    if (firstImage && typeof firstImage === 'object') {
      firstImage = firstImage.value || firstImage.src || firstImage.url || '';
    }

    return (
      firstImage ||
      (variant.featured_image && variant.featured_image.src) ||
      (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) ||
      product.featured_image ||
      (Array.isArray(product.images) && product.images[0]) ||
      (Array.isArray(product.media) && product.media[0] && product.media[0].src) ||
      ''
    );
  }

  function getFirstFrameImage(product) {
    var frameImages = product && product.frame_image;

    if (typeof frameImages === 'string') {
      try {
        frameImages = JSON.parse(frameImages);
      } catch (error) {
        return '';
      }
    }

    if (!Array.isArray(frameImages) || !frameImages[0]) {
      return '';
    }

    var firstFrame = frameImages[0];
    var image = typeof firstFrame === 'string' ? firstFrame : firstFrame.image;

    return typeof image === 'string' ? image.trim() : '';
  }

  function toCents(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    var numberValue = Number(value);

    if (!Number.isFinite(numberValue)) {
      return 0;
    }

    return Math.round(numberValue);
  }

  function dollarsToCents(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    var numberValue = Number(value);

    if (!Number.isFinite(numberValue)) {
      return 0;
    }

    return Math.round(numberValue * 100);
  }

  function formatMoney(cents, symbol) {
    var safeCents = Math.max(0, toCents(cents));
    var safeSymbol = symbol || '$';

    return safeSymbol + (safeCents / 100).toFixed(2);
  }

  function formatDiscountAmount(value, symbol) {
    var numberValue = Number(value);
    var safeSymbol = symbol || '$';

    if (!Number.isFinite(numberValue)) {
      return safeSymbol + '0';
    }

    return safeSymbol + (Number.isInteger(numberValue) ? String(numberValue) : numberValue.toFixed(2));
  }

  function getCouponRule(product) {
    var couponRule = product.couponrule || product.coupon_rule || {};

    if (couponRule && couponRule.value) {
      couponRule = couponRule.value;
    }

    if (typeof couponRule === 'string') {
      try {
        couponRule = JSON.parse(couponRule);
      } catch (error) {
        couponRule = {};
      }
    }

    return couponRule && typeof couponRule === 'object' ? couponRule : {};
  }

  function getDiscountInfo(product, priceCents, compareAtPriceCents) {
    var couponRule = getCouponRule(product);
    var discountType = String(couponRule.discount_type || '');
    // 推荐接口可能包含 coupon_discount，但一口价统一以 couponrule.discount 为准。
    var couponDiscount = Number(couponRule.discount);
    var currencySymbol = product.currency_symbol || '$';

    if (discountType === '1' && Number.isFinite(couponDiscount)) {
      return {
        discountText: couponDiscount + '%',
        suffixText: 'OFF',
        finalPriceCents: Math.max(0, Math.ceil(priceCents * (100 - couponDiscount) / 100)),
      };
    }

    if (discountType === '2' && Number.isFinite(couponDiscount)) {
      return {
        discountText: formatDiscountAmount(couponDiscount, currencySymbol),
        suffixText: 'OFF',
        finalPriceCents: Math.max(0, priceCents - dollarsToCents(couponDiscount)),
      };
    }

    if (compareAtPriceCents > priceCents) {
      return {
        discountText: Math.round((compareAtPriceCents - priceCents) * 100 / compareAtPriceCents) + '%',
        suffixText: 'OFF',
        finalPriceCents: priceCents,
      };
    }

    return {
      discountText: '',
      suffixText: '',
      finalPriceCents: priceCents,
    };
  }

  function getDefaultDiscountText(priceCents, compareAtPriceCents, hasPrice, hasCompareAtPrice) {
    if (!hasPrice || !hasCompareAtPrice || compareAtPriceCents <= priceCents || compareAtPriceCents <= 0) {
      return '';
    }

    // 折扣比例 = (1 - 现价 / 原价) × 100%。
    return Math.round((1 - priceCents / compareAtPriceCents) * 100) + '%';
  }

  function updateText(root, selector, value) {
    var node = root.querySelector(selector);

    if (node && value !== undefined && value !== null) {
      node.textContent = value;
    }
  }

  function updateAllText(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (node) {
      node.textContent = value;
    });
  }

  function updateCard(card, product, config) {
    var variant = getFirstVariant(product);
    var rawPriceNew = variant.price_new !== null && variant.price_new !== undefined && variant.price_new !== '' ? variant.price_new : product.price_new;
    var rawPrice = variant.price !== null && variant.price !== undefined && variant.price !== '' ? variant.price : product.price;
    var rawCompareAtPrice = variant.compare_at_price !== null && variant.compare_at_price !== undefined && variant.compare_at_price !== '' ? variant.compare_at_price : product.compare_at_price;
    var hasPriceNew = rawPriceNew !== null && rawPriceNew !== undefined && rawPriceNew !== '' && Number.isFinite(Number(rawPriceNew));
    var hasPrice = hasPriceNew || (rawPrice !== null && rawPrice !== undefined && rawPrice !== '' && Number.isFinite(Number(rawPrice)));
    var hasCompareAtPrice = rawCompareAtPrice !== null && rawCompareAtPrice !== undefined && rawCompareAtPrice !== '' && Number.isFinite(Number(rawCompareAtPrice));
    // price_new 的单位为美元小数；variant.price/product.price 的单位为分。
    var priceCents = hasPriceNew ? dollarsToCents(rawPriceNew) : toCents(rawPrice);
    var compareAtPriceCents = toCents(rawCompareAtPrice);
    var currencySymbol = product.currency_symbol || '$';
    var productUrl = product.url || (product.handle ? '/products/' + product.handle : '');
    var productTitle = product.title || '';
    var imageSrc = getProductImage(product, variant);
    var frameImageSrc = getFirstFrameImage(product);
    var couponRule = getCouponRule(product);
    var discountInfo = getDiscountInfo(product, priceCents, compareAtPriceCents);
    var defaultDiscountText = getDefaultDiscountText(priceCents, compareAtPriceCents, hasPrice, hasCompareAtPrice);

    // 智能推荐只替换产品数据，继续使用当前组件配置的产品卡片背景色。
    if (config && config.product_item_color) {
      card.style.background = config.product_item_color;
    }

    card.setAttribute('data-product-id', product.product_id || product.id || '');
    card.setAttribute('data-product-handle', product.handle || '');

    if (productUrl) {
      card.querySelectorAll('.product-image a.link, .title a, .buy-now-button a:not(.addCart_icon)').forEach(function (link) {
        link.setAttribute('href', productUrl);
      });

      card.querySelectorAll('[data-url]').forEach(function (node) {
        node.setAttribute('data-url', productUrl);
      });
    }

    card.querySelectorAll('[data-coupon_rule]').forEach(function (node) {
      node.setAttribute('data-coupon_rule', JSON.stringify(couponRule));
    });

    if (Array.isArray(product.newbadges)) {
      card.querySelectorAll('[data-badge]').forEach(function (node) {
        node.setAttribute('data-badge', JSON.stringify(product.newbadges));
      });
    }

    if (productTitle) {
      updateText(card, '.title a', productTitle);
    }

    if (imageSrc) {
      card.querySelectorAll('.product_picture, .flash-sale-product__img').forEach(function (image) {
        image.setAttribute('src', imageSrc);
        image.setAttribute('srcset', imageSrc);
        image.setAttribute('alt', productTitle);
      });
    }

    card.querySelectorAll('.flash-sale-product__frame-image').forEach(function (frameImage) {
      frameImage.remove();
    });

    if (frameImageSrc) {
      var productImage = card.querySelector('.product_picture, .flash-sale-product__img');

      if (productImage) {
        var frameImage = document.createElement('img');
        frameImage.className = 'flash-sale-product__frame-image';
        frameImage.src = frameImageSrc;
        frameImage.alt = '';
        frameImage.loading = 'lazy';
        frameImage.decoding = 'async';
        productImage.insertAdjacentElement('afterend', frameImage);
      }
    }

    updateAllText(card, '.fsd27c-row1 .p2 span', formatMoney(compareAtPriceCents || priceCents, currencySymbol));
    card.querySelectorAll('.drop-discount-price-default').forEach(function (node) {
      node.textContent = defaultDiscountText;
      node.hidden = !defaultDiscountText;
      node.style.setProperty('display', defaultDiscountText ? '' : 'none', 'important');
    });
    // 与左上角 .drop-discount-price-default 使用相同的原价折扣比例。
    updateText(card, '.fsd27c-row2 .span-2', defaultDiscountText);
    updateText(card, '.fsd27c-row2 .span-3', defaultDiscountText ? 'OFF' : '');
    updateText(card, '.fsd27c-row3', formatMoney(discountInfo.finalPriceCents, currencySymbol));
    updateAllText(card, '.buy-now-button .color', formatMoney(discountInfo.finalPriceCents, currencySymbol));
  }

  function mountProducts(productList) {
    document.querySelectorAll('.elevator-nav-block27').forEach(function (block27) {
      var cards = block27.querySelectorAll('.flash-sale-structure-product-con');
      var flashSaleContainer = block27.querySelector('.flash-sale-con');
      var sectionId = flashSaleContainer ? flashSaleContainer.getAttribute('data-section-id') : '';
      var config = (window.FLASH_SALE_CONFIG || {})[sectionId] || {};

      cards.forEach(function (card, index) {
        var product = productList[index];

        if (!product) {
          return;
        }

        updateCard(card, product, config);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var block27List = document.querySelectorAll('.elevator-nav-block27');

    if (!block27List.length) {
      return;
    }

    if (window.__elevatorNavBlock27FlashSaleDataLoading) {
      return;
    }
    window.__elevatorNavBlock27FlashSaleDataLoading = true;

    $.ajax({
        url: 'https://plugin.kriyya.com/api/klaiyi/flash_sale_data',
        method: 'GET',
        timeout: 0,
        headers: {
          Authorization: 'Bearer 6JXquydq6hZG4aJyN8A5',
        },
        success: function (res) {
          res = parseResponse(res);

          if (!res) {
            return;
          }

          console.log('elevator-nav-block27 flash_sale_data:', res);
          mountProducts(getProductList(res));
        },
        error: function (xhr, status, error) {
          console.error('elevator-nav-block27 flash_sale_data error:', status, error, xhr);
        },
      });
  });
})();
